'use strict';

angular.module('msLegacyActivities').directive('msActivityCard', [function () {
  return {
    templateUrl: 'legacyActivities/templates/activity-card.html',
    replace: true,
    restrict: 'AE',
    controller: 'ActivityCardCtrl',
    controllerAs: 'ac',
    bindToController: true,
    scope: {
      activity: '=msActivityCard',
      externalLazyLoad: '=',
      showRemove: '@',
      showAdd: '@'
    }
  };
}]).controller('ActivityCardCtrl', [function () {
  this.$onInit = function () {
    var vm = this;
    vm.modalOpen = false;

    vm.toggleModal = function () {
      vm.modalOpen = !vm.modalOpen;
    };
  };
}]);